module.exports = __webpack_public_path__ + "static/media/status.8c0a947d.svg";